import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: BASE ? `${BASE}/api` : "/api", withCredentials: true });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d?.msg || String(d);
}

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
